export const columns = [
    { id: "date", label: "Date", minWidth: 120 },
    { id: "time", label: "Time", minWidth: 100 },
    { id: "municipality", label: "Municipality", minWidth: 200 },
    { id: "ticket", label: "Ticket Number", minWidth: 150 },
    { id: "disputant", label: "Disputant", minWidth: 150 },
    { id: "evidence", label: "Evidence", minWidth: 180, maxWidth: 332 },
];
